import React, { useState } from 'react'
import * as components from '../../components'
import { HolidaysGrid } from './HolidaysGrid'
import * as rest from '../../services'

const OrganizationHolidaysPane = ({ organization }) => {
  const [apiResponse, setAPIResponse] = useState(null)
  const [loading, setLoading] = useState(false)

  const getHolidays = () => {
    setLoading(true)
    new rest.OrganizationService(`${organization.url}get_holidays`)
      .makeGetRequest()
      .then(
        (response) => {
          setLoading(false)
          setAPIResponse(response)
        },
        (errors) => {
          this.setState({ errors: errors })
        }
      )
  }
  return (
    <components.Slider
      buttonType="dropdown"
      title={
        <span>
          <span className="pr-2">{components.ICONS.HOLIDAY}</span>Holidays
        </span>
      }
      header={
        <span>
          <span className="pr-2">{components.ICONS.HOLIDAY}</span>
          {organization.code} Holidays
        </span>
      }
      onAfterOpen={getHolidays}
    >
      <HolidaysGrid
        onChange={getHolidays}
        apiResponse={apiResponse}
        loading={loading}
        organization={organization}
      />
    </components.Slider>
  )
}

export default OrganizationHolidaysPane
